(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drug-page-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('dtk-drug-navigation-config');
    if (!config) return;
    const handles = new Set(JSON.parse(config.textContent));
    const key = 'dtk-drug-return';
    const ttl = 30 * 60 * 1000;
    const localUrl = (value) => {
      if (!value) return null;
      try {
        const url = new URL(value, location.href);
        return url.origin === location.origin ? url : null;
      } catch { return null; }
    };
    const productUrl = (value) => {
      const url = localUrl(value);
      return url && /\/products\/[^/]+\/?$/.test(url.pathname) ? url : null;
    };
    const drugHandle = (value) => {
      const url = localUrl(value);
      const match = url?.pathname.match(/\/pages\/([^/]+)\/?$/);
      return match && handles.has(match[1]) ? match[1] : null;
    };
    const currentDrug = drugHandle(location.href);
    const referrer = productUrl(document.referrer);
    let returnUrl = referrer;
    if (currentDrug && !returnUrl) {
      try {
        const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (saved?.page === currentDrug && Date.now() - saved.time < ttl) returnUrl = productUrl(saved.url);
      } catch {}
    }
    const remember = (page, url) => {
      try { sessionStorage.setItem(key, JSON.stringify({ page, url: url.href, time: Date.now() })); } catch {}
    };
    if (currentDrug && returnUrl) remember(currentDrug, returnUrl);
    const normalizeLinks = () => {
      document.querySelectorAll('a[href][target]').forEach((link) => {
        if (drugHandle(link.href)) link.removeAttribute('target');
      });
    };
    const prepare = () => {
      normalizeLinks();
      const back = document.querySelector('.dtk-drug-back');
      if (back && returnUrl) {
        back.href = returnUrl.href;
        back.querySelector('span').textContent = back.dataset.productLabel;
        back.addEventListener('click', (event) => {
          if (!event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && referrer && history.length > 1) {
            event.preventDefault();
            history.back();
          }
        });
      }
    };
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      const page = drugHandle(link.href);
      if (!page) return;
      link.removeAttribute('target');
      const source = productUrl(location.href) || returnUrl;
      if (source) remember(page, source);
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
    else prepare();
    document.addEventListener('shopify:section:load', normalizeLinks);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["footer-compact"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 750px)');
    const prepareFooter = () => {
      document.querySelectorAll('.dtk-footer-menu').forEach((menu) => {
        if (menu.dataset.footerReady) return;
        menu.dataset.footerReady = 'true';
        const summary = menu.querySelector('summary');
        const update = () => {
          menu.open = desktop.matches;
          summary.tabIndex = desktop.matches ? -1 : 0;
        };
        summary.addEventListener('click', (event) => {
          if (desktop.matches) event.preventDefault();
        });
        desktop.addEventListener('change', () => {
          if (menu.isConnected) update();
        });
        update();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prepareFooter, { once: true });
    } else {
      prepareFooter();
    }
    document.addEventListener('shopify:section:load', prepareFooter);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frontend-readability"] && !Shopify.designMode) return;
  try {
    const prepareReadingTables = () => {
    document.querySelectorAll('main .rte:not(.product__description) table').forEach((table) => {
      if (table.scrollWidth > table.clientWidth) table.tabIndex = 0;
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareReadingTables, { once: true });
  } else {
    prepareReadingTables();
  }
  document.fonts.ready.then(prepareReadingTables);
  window.addEventListener('resize', prepareReadingTables);
  document.addEventListener('shopify:section:load', prepareReadingTables);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-table-standard"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateTableScroll = (wrapper) => {
      const table = wrapper.querySelector(':scope > table');
      if (!table) return;
      const overflowing = wrapper.clientWidth > 0 && wrapper.scrollWidth > wrapper.clientWidth + 1;
      if (overflowing) {
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        const label = table.caption?.textContent.trim()
          || Array.from(table.querySelectorAll('thead th')).map((cell) => cell.textContent.trim()).join(', ')
          || table.closest('product-info')?.querySelector('h1, h2')?.textContent.trim()
          || document.title;
        wrapper.setAttribute('aria-label', label);
      } else {
        wrapper.removeAttribute('tabindex');
        wrapper.removeAttribute('role');
        wrapper.removeAttribute('aria-label');
      }
    };
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach(({ target }) => updateTableScroll(target));
    });
    const prepareProductTables = () => {
      document.querySelectorAll('.product__description.rte table').forEach((table) => {
        let wrapper = table.parentElement;
        if (!wrapper.classList.contains('dtk-product-table-scroll')) {
          if (wrapper.tagName !== 'DIV' || wrapper.children.length !== 1 || wrapper.classList.contains('product__description')) {
            wrapper = document.createElement('div');
            table.before(wrapper);
            wrapper.append(table);
          }
          wrapper.classList.add('dtk-product-table-scroll');
          const columnCount = Math.max(...Array.from(table.rows, (row) => row.cells.length));
          table.classList.toggle('dtk-product-table--wide', columnCount >= 4);
          const headings = Array.from(table.querySelectorAll('thead th'), (cell) => cell.textContent.trim().toLowerCase());
          table.classList.toggle('dtk-product-table--drug', headings.includes('drug name') && headings.includes('drug information'));
          table.removeAttribute('tabindex');
          resizeObserver.observe(wrapper);
        }
        updateTableScroll(wrapper);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prepareProductTables, { once: true });
    } else {
      prepareProductTables();
    }
    document.fonts.ready.then(prepareProductTables);
    document.addEventListener('shopify:section:load', prepareProductTables);
  })();
  } catch(e) { console.error(e); }
})();

})();
